
/* ///////////////////////////////// Navigation */

function initNav(){
  var togglenav = document.querySelector("#nav-toggle");
  var nav = document.querySelector("#nav");
  var header = document.querySelector("#header");
  var overlay = document.querySelector("#overlay");

  document.body.classList.remove('locked');
  nav.classList.remove('visible');
  header.classList.remove('nav-visible');
    
  togglenav.addEventListener('click', function(e){
    e.preventDefault();
    openCloseNav();
  });  
  overlay.addEventListener('click', function(e){
    openCloseNav();
  });  
  window.addEventListener('keydown', function(e){
    if(e.key === "Escape") {
      openCloseNav();
    }
  });  
}


function openCloseNav(){
  var nav = document.querySelector("#nav");
  var header = document.querySelector("#header");
  if(nav.classList.contains('visible')){
    document.body.classList.remove('locked');
    nav.classList.remove('visible');
    header.classList.remove('nav-visible');
  } else {
    document.body.classList.add('locked');
    nav.classList.add('visible');
    header.classList.add('nav-visible');
  }  
}

/* ///////////////////////////////// Plyrs */

function initPlyr(){
  var player_element = document.querySelector('#player');
  var intro = document.querySelector('.film-intro');
  // safari / ios
  var ua = window.navigator.userAgent;
  var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  var webkit = !!ua.match(/WebKit/i);
  var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

  if(player_element && !iOSSafari){
    var custom_ratio = player_element.dataset.ratio || "16:9";
    var button_text = player_element.dataset.playtext || "Watch the trailer";
    var pp = new Plyr('#player', {
      controls: ['play-large', 'play', 'progress', 'mute', 'fullscreen'],
      ratio: custom_ratio,
      vimeo: {
        portrait: false
      },
      i18n: {
        enterFullscreen: 'Fullscreen',
        playlarge: button_text
      }
    });
    // set poster
    if(player_element.getAttribute('data-poster') != ""){
      pp.poster = player_element.getAttribute('data-poster');
    }
    // fire ready
    pp.on('ready', function(event) {
      var instance = event.detail.plyr;
      setTimeout(function(){
        intro.classList.add('ready');
      }, 500);
    });
  }  else if(player_element) {
    setTimeout(function(){
      intro.classList.add('ready');
    }, 500);
  }
}

/* ///////////////////////////////// Home */
var intvals = {};

function initHome(){
  var home = document.querySelector('.home');
  if(home){
    var articles = home.querySelectorAll('article');
    
    articles.forEach(function(article) {
      
      
      var video = article.querySelector('video');
    
      article.addEventListener('mouseover', function(){
        clearInterval(intvals[article.id]);
        if(video){
          setTimeout(function(){
            video.play();
          }, 250);
        }
        article.classList.add('hover');
        article.classList.toggle('hovered');
      });

      article.addEventListener('mouseleave', function(e){
        if(video){
          setTimeout(function(){
            video.pause();
          }, 250);
        }
        intvals[article.id] = setTimeout(function(){
          article.classList.remove('hover');
          article.classList.remove('hovered');
        }, 2000);
      });
    });
  }  
}

function initReadmores(){
  var readmores = document.querySelectorAll('.readmore');
  readmores.forEach(function(link){
    link.addEventListener('click', function(){
      
      var target = document.querySelector(link.dataset.target);
      if(target) {
          target.classList.toggle('visible');
      }
      var oldtext = link.textContent;
      link.textContent = link.dataset.text;
      link.dataset.text = oldtext;
    });
  });
}

/* ///////////////////////////////// Slideshows */

function initSlideshows(){
  var slideshows = document.querySelectorAll('.slideshow');
  // console.log("init slideshows");
  slideshows.forEach(function(slideshow){
    var flkty = new Flickity( slideshow, {
      cellAlign: 'left',
      contain: true,
      draggable: true,
      freeScroll: true,
      pageDots: false,
      prevNextButtons: false,
      // wrapAround: true
    });

    var next_button = slideshow.parentElement.querySelector('.next_button');
    if(next_button){
      next_button.addEventListener('click', function(){
        flkty.next(true);
      });
    }
  });
}




/* ///////////////////////////////// Transitions */


// let links = document.querySelectorAll('a[href]');
// if(links){
//   links.forEach((link)=> {
//     link.addEventListener('click', function(e){
//       let body = document.querySelector('body');
//       e.preventDefault();
//       body.classList.add('loading');
//     })
//   })
// }
var options = {
  linkSelector: 'a[href^="' +
    window.location.origin +
    '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]), a[href^="#"]:not([data-no-swup])',
  debugMode: true,
  containers: ["#page"]

};
var swup = new Swup(options);

function init() {
  window.scrollTo(0, 0);
  initNav();
  initHome();
  initPlyr();
  initSlideshows();
  initReadmores();
}
function unload(){
  openCloseNav();
}

init();

// this event runs for every page view after initial load
swup.on('contentReplaced', init);
swup.on('willReplaceContent', unload);